import { getBaseUrl, request } from 'src/helper/api';

export const getRequests = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/vendors/requests`,
      contentType: 'json',
      token,
      signal,
    },
    'vendor/request/getRequests',
  );

export const getRequestDetails = (token?: string, workOrderId?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/vendors/requests/${workOrderId}`,
      contentType: 'json',
      token,
      signal,
    },
    'vendor/request/getRequestDetails',
  );

export const claimRequest = (workOrderId?: string, token?: string) => {
  const url = `${getBaseUrl()}api/work-orders/${workOrderId}/actions/claimWorkOrder`;
  return request(
    {
      method: 'POST',
      url,
      contentType: 'json',
      token,
    },
    'vendor/request/claimWorkOrder',
  );
};

export const passRequest = (workOrderId?: string, token?: string) => {
  const url = `${getBaseUrl()}api/work-orders/${workOrderId}/actions/passWorkOrder`;
  return request(
    {
      method: 'POST',
      url,
      contentType: 'json',
      token,
    },
    'vendor/request/passWorkOrder',
  );
};

export const addRequestAvailabilityFromWorkOrder = (workOrderId?: string, token?: string) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/actions/requestAvailability`,
      contentType: 'json',
      token,
    },
    'vendor/request/addRequestAvailabilityFromWorkOrder',
  );

export type TimeSlotType = {
  date: string;
  available_slots: {
    service_window_reference_id: string;
    label: string;
    start_time: string;
    end_time: string;
  }[];
};

export const getVendorAvailability = (workOrderId?: string, vendorId?: string, token?: string) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/schedule/vendor/${vendorId}/availability`,
      contentType: 'json',
      token,
    },
    'work-order/getVendorAvailability',
  );
